import React from 'react';
import './footer.css';
import { SUPPORT_PHONE, SUPPORT_PHONE_TEL } from '../constants/contact';
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaLocationDot,
  FaPhone,
  FaEnvelope,
  FaArrowRight,
} from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import logo from '../assets/images/rupya_logo.png';

const quickLinks = [
  ['Apply for Loan', '/apply-now'],
  ['About Us', '/about-us'],
  ['Contact Us', '/contact-us'],
  ['Repay Loan', '/repay-loan'],
  ['FAQs', '/faqs'],
];

const legalLinks = [
  ['Terms & Conditions', '/terms-conditions'],
  ['Privacy Policy', '/privacy-policy'],
  ['Fair Practice Code', '/fair-practice-code'],
  ['Corporate Governance', '/corporate-governance'],
  ['Interest Rate Policy', '/interest-rate-policy'],
  ['Risk Management', '/risk-management-policy'],
];

const socialLinks = [
  {
    icon: FaFacebookF,
    label: 'Facebook',
    href: 'https://www.facebook.com/share/1Ty4sjNghp/',
  },
  {
    icon: FaLinkedinIn,
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/mr-rupya/?viewAsMember=true',
  },
  {
    icon: FaInstagram,
    label: 'Instagram',
    href: 'https://www.instagram.com/mr_rupya/?igsh=MTZlemN5Y3JxbXNjdw%3D%3D#',
  },
];

const Footer = () => {
  return (
    <footer className="ft footer-section" aria-label="Site footer">
      <div className="ft-bg" aria-hidden="true" />

      <div className="ft-cta">
        <div className="ft-inner ft-cta-inner">
          <div className="ft-cta-copy">
            <span className="ft-cta-tag">Start today</span>
            <h2 className="ft-cta-title">
              Ready for your <span>instant loan?</span>
            </h2>
            <p className="ft-cta-text">
              Apply online in minutes — fast approval, clear terms, direct disbursal.
            </p>
          </div>
          <Link to="/apply-now" className="ft-cta-btn">
            Apply now
            <FaArrowRight aria-hidden="true" />
          </Link>
        </div>
      </div>

      <div className="ft-main">
        <div className="ft-inner">
          <div className="ft-grid">
            <div className="ft-brand">
              <Link to="/" className="ft-logo-link">
                <img src={logo} alt="MR Rupya" className="ft-logo" width={160} height={48} />
              </Link>
              <p className="ft-about">
                <strong>Marathon Finlease Private Limited</strong> — empowering India&apos;s
                workforce with smarter, faster lending through MR Rupya.
              </p>
              <div className="ft-social">
                {socialLinks.map(({ icon: Icon, label, href }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ft-social-link"
                    aria-label={label}
                  >
                    <Icon />
                  </a>
                ))}
              </div>
            </div>

            <nav className="ft-nav" aria-label="Quick links">
              <h3 className="ft-heading">Quick Links</h3>
              <ul className="ft-links">
                {quickLinks.map(([label, path]) => (
                  <li key={path}>
                    <Link to={path}>{label}</Link>
                  </li>
                ))}
              </ul>
            </nav>

            <nav className="ft-nav" aria-label="Legal pages">
              <h3 className="ft-heading">Legal</h3>
              <ul className="ft-links">
                {legalLinks.map(([label, path]) => (
                  <li key={path}>
                    <Link to={path}>{label}</Link>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="ft-contact">
              <h3 className="ft-heading">Get in Touch</h3>
              <ul className="ft-contact-list">
                <li>
                  <FaLocationDot className="ft-contact-icon" aria-hidden="true" />
                  <span>Office no. 304, Laxman Palace, Delhi</span>
                </li>
                <li>
                  <FaEnvelope className="ft-contact-icon" aria-hidden="true" />
                  <a href="mailto:info@mrrupya.com">info@mrrupya.com</a>
                </li>
                <li>
                  <FaPhone className="ft-contact-icon" aria-hidden="true" />
                  <a href={`tel:${SUPPORT_PHONE_TEL}`}>{SUPPORT_PHONE}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="ft-bottom">
        <div className="ft-inner ft-bottom-inner">
          <p className="ft-copy">
            &copy; {new Date().getFullYear()} Marathon Finlease Private Limited. All rights
            reserved.
          </p>
          <p className="ft-disclaimer">
            Loans are subject to eligibility and approval. Please read terms before applying.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
